<mat-dialog-content>
  <div class="dialog-content-container">

    <div class="dialog-title text-center mb-4">{{ title }}</div>

    <div class="form-group mb-3">
      <mat-form-field floatLabel="always" appearance="outline" class="w-100">
        <mat-label>Phone Number</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="keyword" (keydown.enter)="search($event)"
               type="tel"
               required
               placeholder="Enter your phone number">
      </mat-form-field>
    </div>

    <div class="membership-info py-2 px-2 highlight-background" *ngIf="membership" (click)="submit()">
      <div class="d-flex align-items-center mb-2">
        <div class="symbol-circle me-2">{{ membership?.name?.charAt(0).toUpperCase() }}</div>
        <div>
          <span class="membership-name text-dark me-2">{{ membership?.name }}</span><br>
          <span class="membership-phone text-muted-700 small">{{ membership?.phoneNo }}</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons-container d-flex justify-content-center w-100 p-3">
    <div class="cancel-button-container col-4 me-3">
      <button class="btn btn-light border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="search-button-container col-8">
      <button
        class="btn btn-primary text-white w-100 h-100 d-flex align-items-center justify-content-center"
        (click)="search()"
        [disabled]="!keyword">
        <i class="fa fa-search me-2"></i>
        <span>Search</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
